import { Injectable, Injector } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApplicationConstants } from '../../../../constants/application.constants';
import {
  ProviderFlexLookupResult,
  ProviderFlexSearchItem,
  ProviderFlexSearchRequest,
  ProviderFlexSearchResponse,
} from 'src/app/models/provider-flex';
import { isNullOrUndefined } from '../../../../utility';
import { HttpClientService } from '../../http/http-client-data/http-client-service';

@Injectable({
  providedIn: 'root'
})
export class ProviderFlexDataService extends HttpClientService {
  private _issuedAuthorizationProviderFlexLookupResult: ProviderFlexLookupResult;

  constructor(protected injector: Injector) {
    super(injector, ApplicationConstants.dataServiceClientIDs.providerFlexDataService);
  }

  private cloneProviderFlexLookupResult(providerFlexLookupResult: ProviderFlexLookupResult): ProviderFlexLookupResult {
    return providerFlexLookupResult ? { ...providerFlexLookupResult } : providerFlexLookupResult;
  }

  get issuedAuthorizationProviderFlexLookupResult(): ProviderFlexLookupResult {
    return this.cloneProviderFlexLookupResult(this._issuedAuthorizationProviderFlexLookupResult);
  }

  set issuedAuthorizationProviderFlexLookupResult(providerFlexLookupResult: ProviderFlexLookupResult) {
    this._issuedAuthorizationProviderFlexLookupResult = this.cloneProviderFlexLookupResult(providerFlexLookupResult);
  }

  clearIssuedAuthorizationProviderFlexLookupResult(): void {
    this._issuedAuthorizationProviderFlexLookupResult = undefined;
  }

  getProviderFlexSearchItems(postBody: ProviderFlexSearchRequest): Observable<ProviderFlexSearchItem[]> {
    return this.http.post<ProviderFlexSearchResponse>(
      `${this.environment.apiUrl}${ApplicationConstants.api.providerFlexEndpoint}`,
      postBody,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      }
    ).pipe(
      map((providerFlexSearchResponse: ProviderFlexSearchResponse) => {
        if (isNullOrUndefined(providerFlexSearchResponse) || !providerFlexSearchResponse.providerFlexSearchItems) {
          console.error('Provider Flex endpoint returned an invalid response shape');
          this.messageService.showErrorSnackbar(ApplicationConstants.errorMessages.genericApiFailMessage);

          return [];
        }

        return providerFlexSearchResponse.providerFlexSearchItems;
      }),
      catchError((error: any) => {
        console.error('Error calling Provider Flex endpoint', error);
        this.messageService.showErrorSnackbar(ApplicationConstants.errorMessages.genericApiFailMessage);

        return of([]);
      }),
    );
  }
}
